export default {
  FlightStopsTracker__CAPTION_NO_PLANE_CHANGE: "No plane change",
  FlightStopsTracker__CAPTION_NONSTOP: "Nonstop",
  FlightStopsTracker__CAPTION_PLANE_CHANGE: ({ stopStations }) => `Plane change ${stopStations}`,
  FlightStopsTracker__STOPS: ({ numberStops }) =>
    `${numberStops} ${numberStops > 1 ? "stops" : "stop"}`,
};
